import {
    faUsersCog,
    faUsers,
    faLayerGroup,
    faGlobeEurope,
    faChartLine,
    faFileExcel,
    faEnvelope,
    faTachometerAlt,
    faCog,
    faClock,
    faListOl} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        to: "/admin",
        icon: faUsersCog,
        title: "Admin",
    },
    {
        icon: faUsers,
        title: "Users",
        sub: [
            {
                to: "/admin/users",
                icon: faUsers,
                title: "Users",
            },
            {
                feature: "allow_groups_update",
                to: "/admin/groups",
                icon: faLayerGroup,
                title: "Groups",
            },
        ]
    },
    {
        to: "/admin/translations",
        icon: faGlobeEurope,
        title: "Translations",
        feature: 'database_translations'
    },
    {
        to: "/admin/stats",
        icon: faChartLine,
        title: "Stats",
    },
    {
        to: "/admin/waitlist",
        icon: faListOl,
        title: "Waitlist",
    },
    {
        icon: faFileExcel,
        title: "Reports",
        sub: [
            {
                to: "/admin/reports",
                icon: faFileExcel,
                title: "Reports",
            },
            {
                to: "/admin/scheduled-reports",
                icon: faClock,
                title: "Scheduled Reports",
            },
        ]
    },
    {
        to: "/admin/imports",
        icon: faFileExcel,
        title: "Imports",
    },
    {
        to: "/admin/push-notifications",
        icon: faEnvelope,
        title: "Push Notifications",
        feature: 'allow_push_notifications'
    },
    {
        to: "/admin/tests",
        icon: faTachometerAlt,
        title: "Site Tests",
    },
    {
        to: "/admin/site-config",
        icon: faCog,
        title: "Site Config",
    }
];
